/**
 * Job launcher (Admin API `api/admin-jobs`): list the launchable jobs, start one (202 `{ jobId }`, 409 when it or
 * its lock group is already running), poll a run. The history itself is `statisticsApi.getLogs`.
 */
import { ApiService } from '../apiService'
import type { AdminJobDto, StartedJobDto } from '../types/adminJobs'
import type { StatisticsJobDto } from '../types/statistics'

export const adminJobsApi = {
  list: () => ApiService.get<AdminJobDto[]>('/admin/admin-jobs'),
  start: (key: string, parameters?: object) =>
    ApiService.post<StartedJobDto>(`/admin/admin-jobs/${encodeURIComponent(key)}/start`, parameters ?? {}),
  getRun: (id: string) => ApiService.get<StatisticsJobDto>(`/admin/admin-jobs/runs/${encodeURIComponent(id)}`),
}
